import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { usePublicContent } from '../../context/PublicContent';
import { closeMobileMenus } from '../../lib/pageEffects';

export const ContentNavigation = ({mobile = false, footer = false}) => {
  const {cities} = usePublicContent();
  const prefix = footer ? 'footer' : mobile ? 'mobile' : 'desktop';
  const links = <>
    <Link to="/blog" onClick={closeMobileMenus} data-testid={`${prefix}-blog-link`}>Articles</Link>
    {cities.length > 0 && <><Link to="/locations" onClick={closeMobileMenus} data-testid={`${prefix}-service-areas-link`}>Service Areas</Link>{!footer && cities.map(city => <Link key={city.slug} to={`/locations/${city.slug}`} onClick={closeMobileMenus} data-testid={`${prefix}-city-${city.slug}`}>{city.title.replace(' Criminal Defense', '')}</Link>)}</>}
  </>;
  if (footer) return <div className="content-footer-links">{links}<Link to="/staff/login" data-testid="footer-staff-link">Staff Sign In</Link></div>;
  if (mobile) return <div className="content-mobile-links">{links}</div>;
  return <div className="content-nav-dropdown"><Link to="/blog" className="content-nav-label" data-testid="desktop-resources-link">Resources<ChevronDown size={12} aria-hidden="true" /></Link><div className="content-nav-menu">{links}</div></div>;
};